import type { Slicer } from '@swf/core/store';

import type { SportsPromotionGridState } from './types';

export const selectors = (slice: Slicer<SportsPromotionGridState>) => ({
  hasPreloaded: () => slice((state) => state.hasPreloaded),
  isLoading: () => slice((state) => state.isCrmLoading || state.isIceLoading),
  crm: () => slice((state) => state.crm),
  hasCrmErrored: () => slice((state) => state.hasCrmErrored),
  ice: () => slice((state) => state.ice),
  hasIceErrored: () => slice((state) => state.hasIceErrored),
  hasCrmRequestComplete: () => slice((state) => Boolean(state.hasCrmErrored || state.crm)),
  hasCrmAndIceErrored: () => slice((state) => Boolean(state.hasIceErrored && state.hasCrmErrored))
});
